import { PROGRAM_TARGET } from '@admin_pages/OwnerProgram/constants';
import { dayjs } from '@/utils/formatter';
import { BUTTON_ACTION, CTA_POSITIONS } from '../constants';

const formatDate = date => (date ? dayjs(date).format('YYYY-MM-DD') : '');

const buildActionConfig = button => {
  if (button.action === BUTTON_ACTION.OPEN_LINK) {
    return { url: button.url };
  }

  if (button.action === BUTTON_ACTION.FILL_DATA) {
    return {
      fields: button.textFields.map(field => ({
        name: field.title,
        type: field.inputType,
      })),
    };
  }

  // `submit` carries no config.
  return null;
};

const buildCtas = (buttonSettings, { removeInactive = false } = {}) => {
  const count = buttonSettings.ctaType === 'double' ? 2 : 1;

  const activeCtas = buttonSettings.buttons
    .slice(0, count)
    .map((button, index) => ({
      position: CTA_POSITIONS[index],
      label: button.label,
      action_type: button.action,
      action_config: buildActionConfig(button),
    }));

  if (!removeInactive) {
    return activeCtas;
  }

  const removedCtas = CTA_POSITIONS.slice(count).map(position => ({
    position,
    destroy: true,
  }));

  return [...activeCtas, ...removedCtas];
};

const appendFormData = (formData, key, value) => {
  if (value === null || value === undefined) return;

  if (value instanceof Blob) {
    formData.append(key, value);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) =>
      appendFormData(formData, `${key}[${index}]`, item)
    );
    return;
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(([childKey, childValue]) =>
      appendFormData(formData, `${key}[${childKey}]`, childValue)
    );
    return;
  }

  formData.append(key, value);
};

export const buildProgramFormData = ({
  programInformation,
  buttonSettings,
  programTarget,
  mediaId = null,
  programStatus,
  removeInactiveCtas = false,
}) => {
  const formData = new FormData();
  const isSpecific = programTarget.targetType === PROGRAM_TARGET.SPECIFIC;

  appendFormData(formData, 'name', programInformation.name);
  appendFormData(formData, 'description', programInformation.description);
  appendFormData(formData, 'media_id', mediaId);
  appendFormData(
    formData,
    'start_date',
    formatDate(programInformation.startDate)
  );
  appendFormData(formData, 'end_date', formatDate(programInformation.endDate));
  appendFormData(
    formData,
    'quota',
    programInformation.quota ? Number(programInformation.quota) : null
  );
  appendFormData(formData, 'target_type', programTarget.targetType);
  appendFormData(formData, 'status', programStatus);

  if (isSpecific) {
    appendFormData(formData, 'owner_target_csv', programTarget.csvFile.file);
  }

  appendFormData(
    formData,
    'ctas',
    buildCtas(buttonSettings, { removeInactive: removeInactiveCtas })
  );

  return formData;
};
